import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tourOptionsApi from '@/features/dashboard/tourOptions/api/tourOptionsApi.ts';
import { tourOptionsApiQueryKeys } from '@/features/dashboard/tourOptions/api/tourOptionsApi.queryKeys.ts';
import { invalidateTourStatsQueries } from '@/utils/invalidateTourStatsQueries.ts';

const useReorderTourOptions = (tourId: string) => {
  const queryClient = useQueryClient();
  const queryKey = tourOptionsApiQueryKeys.byTourId(tourId);

  return useMutation<void, Error, string[], { toastId: string | number }>({
    mutationFn: (optionIds) => tourOptionsApi.reorder(tourId, optionIds),
    onMutate: () => ({
      toastId: toast.loading('Zapisywanie kolejności...'),
    }),
    onSuccess: (_data, _variables, context) => {
      toast.success('Kolejność została zapisana', { id: context?.toastId });
    },
    onError: (error, _variables, context) => {
      toast.error('Nie udało się zmienić kolejności opcji', {
        id: context?.toastId,
        description: error.message,
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey });
      invalidateTourStatsQueries(queryClient, tourId);
    },
  });
};

export default useReorderTourOptions;
